module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /home/ingvars/BNC-Lab/front/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 3